import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	deprecatedEpicMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notInContextFieldMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notInContextFieldMessageIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notInContextFieldMessageIssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	deprecatedEpicMessage: {
		id: 'jql-builder-basic.services.use-fields.deprecated-epic-message',
		defaultMessage:
			'<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead.',
		description: 'Warning message for Epic Link deprecation',
	},
	notInContextFieldMessage: {
		id: 'jql-builder-basic.services.use-fields.not-in-context-field-message',
		defaultMessage: 'This field is unavailable for the selected project and/or issue type.',
		description: 'Warning message for not in context field',
	},
	notInContextFieldMessageIssueTermRefresh: {
		id: 'jql-builder-basic.services.use-fields.not-in-context-field-message-issue-term-refresh',
		defaultMessage: 'This field is unavailable for the selected project and/or work type.',
		description: 'Warning message for not in context field',
	},
	notInContextFieldMessageIssueTermRefreshGalaxia: {
		id: 'jql-builder-basic.services.use-fields.not-in-context-field-message-issue-term-refresh-galaxia',
		defaultMessage: 'This field is unavailable for the selected space and/or work type.',
		description: 'Warning message for not in context field',
	},
});
export default messages;
